/* eslint-disable react/jsx-filename-extension */
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import PreparationCoursePage from '../../containers/PreparationCoursePage';

const CursoPreparatorioMilitar = ({ location }) => {
  const data = useStaticQuery(graphql`
    query {
      cursoPreparatorioMilitarJson {
        hero {
          title
          subtitle
          description
          backgroundImage {
            childImageSharp {
              fluid(quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                presentationWidth
                presentationHeight
              }
            }
          }
          mobileBackgroundImage {
            childImageSharp {
              fluid(quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                presentationWidth
                presentationHeight
              }
            }
          }
          image {
            childImageSharp {
              fluid(maxWidth: 601, maxHeight: 715, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                presentationWidth
                presentationHeight
              }
            }
          }
          action {
            label
            link
          }
        }
        faq {
          title
          subtitle
          videoLink
          videoImage {
            childImageSharp {
              fluid(maxWidth: 570, maxHeight: 350, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                presentationWidth
                presentationHeight
              }
            }
          }
          image1 {
            childImageSharp {
              fluid(maxWidth: 310, maxHeight: 190, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                presentationWidth
                presentationHeight
              }
            }
          }
          image2 {
            childImageSharp {
              fluid(maxWidth: 188, maxHeight: 115, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                presentationWidth
                presentationHeight
              }
            }
          }
          image3 {
            childImageSharp {
              fluid(maxWidth: 188, maxHeight: 115, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                presentationWidth
                presentationHeight
              }
            }
          }
          image4 {
            childImageSharp {
              fluid(maxWidth: 190, maxHeight: 190, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                presentationWidth
                presentationHeight
              }
            }
          }
          items {
            title
            content
          }
        }
        teachers
        benefits {
          title
          items
          primaryAction {
            label
            link
          }
        }
      }
    }
  `);

  const courseData = data.cursoPreparatorioMilitarJson;

  return (
    <PreparationCoursePage
      title="Curso Preparatório para Carreiras Militares - Garra"
      description="Está buscando fazer carreira militar? Com o Garra você tem tudo o que precisa para buscar a aprovação nos concursos militares. Saiba mais!"
      location={location}
      data={courseData}
    />
  );
};

CursoPreparatorioMilitar.propTypes = {
  location: PropTypes.object.isRequired,
};

export default CursoPreparatorioMilitar;
